import PrivateLeagueBasicModel from "./PrivateLeagueModel";

export default class PrivateLeagueFullModel extends PrivateLeagueBasicModel {
    public members: string[] = [];
}